import { useEffect, useRef, useState } from "react";

const useTimedBoolean = (
  defaulValue: boolean,
  delay: number
): [boolean, () => void] => {
  const [state, setState] = useState(defaulValue);
  const timerRef = useRef(null);

  useEffect(() => {
    if (state !== defaulValue) {
      timerRef.current = setTimeout(() => {
        setState(defaulValue);
      }, delay);
    }

    return () => {
      clearTimeout(timerRef.current);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  const trigger = () => setState(!defaulValue);

  return [state, trigger];
};

export default useTimedBoolean;
